module.exports = __webpack_public_path__ + "static/media/upload.d8d40a5f.svg";